import { render, staticRenderFns } from "./DouYinCardPage.vue?vue&type=template&id=04dcac1f&scoped=true"
import script from "./DouYinCardPage.vue?vue&type=script&lang=js"
export * from "./DouYinCardPage.vue?vue&type=script&lang=js"
import style0 from "./DouYinCardPage.vue?vue&type=style&index=0&id=04dcac1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dcac1f",
  null
  
)

export default component.exports